@if (!isLoggedIn()) {
  <div class="login-shell">
  <div class="login-screen">

    <div class="login-card">
      <img class="login-card__logo" [src]="headerLogoSrc()" alt="Creditreform" />
      <h1 class="login-card__title">{{ 'app.title' | t }}</h1>
      <p class="login-card__subtitle">{{ 'login.subtitle' | t }}</p>

      @if (showTestAkten()) {
        <div class="login-card__field">
          <label class="login-card__label" for="testAkte">{{ 'login.testCase' | t }}</label>
          <select
            id="testAkte"
            #testAkteSelect
            class="login-card__select"
            [value]="selectedTestAkte()"
            (change)="onTestAkteSelect(testAkteSelect.value)">
            <option value="">{{ 'login.testCasePlaceholder' | t }}</option>
            @for (akte of testAkten(); track akte.aktennummer + '|' + (akte.unterakte ?? '0')) {
              <option [value]="akte.aktennummer + '|' + (akte.unterakte ?? '0')">{{ akte.label }}@if (testAkteStatus(akte); as status) { - {{ status }} }</option>
            }
          </select>
        </div>
      }

      <div class="login-card__field">
        <label class="login-card__label" for="aktennummer">{{ 'login.aktennummer' | t }}</label>
        <input
          id="aktennummer"
          #aktennummerInput
          class="login-card__input"
          type="text"
          placeholder="z.B. 2600001234255-0"
          [value]="loginAktennummer()"
          (focusin)="tracking.beginLogin()" (input)="onAktennummerInput(aktennummerInput.value)"
          (keydown)="onLoginKeyDown($event)"
        />
      </div>

      <div class="login-card__field">
        <label class="login-card__label" for="pin">{{ 'login.pin' | t }}</label>
        <input
          id="pin"
          #pinInput
          class="login-card__input"
          type="password"
          [placeholder]="'login.pinPlaceholder' | t"
          [value]="loginPin()"
          (focusin)="tracking.beginLogin()" (input)="onPinInput(pinInput.value)"
          (keydown)="onLoginKeyDown($event)"
          autofocus
        />
      </div>

      @if (loginError()) {
        <p class="login-card__error">{{ loginError() }}</p>
      }

      <button
        class="login-card__btn"
        type="button"
        data-track="login_submit" (click)="login()"
        [disabled]="loginAktennummer().length === 0 || loginPin().length === 0 || isLoading()">
        @if (isLoading()) { {{ 'login.loading' | t }} } @else { {{ 'login.submit' | t }} }
      </button>
      <p class="login-card__privacy">
        {{ 'p1.privacyIntro' | t }}
        <button type="button" data-track="privacy" (click)="datenschutzOpen.set(true)">Datenschutzerklärung</button>.
      </p>

    </div>
  </div>
    <footer class="app-footer">
      <div class="app-footer__meta app-footer__meta--stacked">
        <button class="app-footer__link" type="button" data-track="impressum" (click)="openImpressum()">Impressum</button>
        <button class="app-footer__link" type="button" data-track="privacy" (click)="datenschutzOpen.set(true)">Datenschutzerklärung</button>
      </div>
    </footer>
  </div>
} @else {
  <div class="app-shell">
    <header class="app-header">
      <div class="app-header__inner">
        <div class="app-header__brand-block">
          <img class="app-header__logo" [class.app-header__logo--location]="hasLocationHeaderLogo()" [src]="headerLogoSrc()" [alt]="currentCompanyName()" />
          <span class="app-header__brand">{{ 'app.title' | t }}</span>
          <app-language-selector class="app-header__lang"></app-language-selector>
        </div>
        <div class="app-header__actions">
          @if (isDevMode()) {
            <button class="app-header__debug-trigger" type="button" data-track="case_details" (click)="openCaseModal()">
              <span class="app-header__debug-title">{{ 'header.caseView' | t }}</span>
            </button>
          }
          <button class="app-header__logout" type="button" data-track="logout" (click)="logout()">{{ 'header.logout' | t }}</button>
        </div>
      </div>
    </header>

    <main class="app-main">
      <app-dashboard (reloginRequired)="requireReLogin($event)"></app-dashboard>
    </main>

    <footer class="app-footer">
      <div class="app-footer__membership">
        <img class="app-footer__membership-logo" src="bdiu-logo.jpg" alt="BDIU" />
        <span>{{ 'p1.membership' | t }}<br />Deutscher Inkasso-Unternehmen e.V.</span>
        <div class="app-footer__meta">
          <button class="app-footer__link" type="button" data-track="impressum" (click)="openImpressum()">Impressum</button>
          <button class="app-footer__link" type="button" data-track="privacy" (click)="datenschutzOpen.set(true)">Datenschutzerklärung</button>
        </div>
      </div>
      <div class="app-footer__meta">
        <span>{{ footerCopyright() }}</span>
      </div>
    </footer>
  </div>

  @if (caseModalOpen()) {
    <div class="case-modal" role="dialog" aria-modal="true" [attr.aria-label]="'header.caseView' | t">
      <div class="case-modal__panel">
        <header class="case-modal__header">
          <h2 class="case-modal__title">{{ 'header.caseView' | t }}</h2>
          <button type="button" class="case-modal__close" (click)="closeCaseModal()" [attr.aria-label]="'common.close' | t">✕</button>
        </header>

        <div class="case-modal__body">
          @if (caseModalLoading()) {
            <p class="case-modal__state">{{ 'caseView.loading' | t }}</p>
          } @else if (caseModalError()) {
            <p class="case-modal__state case-modal__state--error">{{ caseModalError() }}</p>
          } @else if (caseModalData(); as caseData) {
            @if (caseData.source === 'db' && caseData.akte) {
              <section class="case-hero">
                <div class="case-hero__content">
                  <p class="case-hero__eyebrow">{{ 'caseView.internalRecord' | t }}</p>
                  <h3 class="case-hero__title">{{ 'caseView.case' | t }} {{ caseData.akte.aktennummer }}</h3>
                  <p class="case-hero__subtitle">{{ 'caseView.subcase' | t }} {{ caseData.akte.unterakte || ('common.notAvailable' | t) }}</p>
                  <p class="case-hero__meta">{{ 'caseView.creditorPrefix' | t }} {{ caseData.akte.gl_name || ('common.notAvailable' | t) }}</p>
                  <span class="case-badge case-badge--stadium">{{ formatStadium(caseData.akte.stadium) }}</span>
                </div>
                <article class="case-hero__total">
                  <span class="case-hero__total-label">{{ 'caseView.totalOpen' | t }}</span>
                  <strong class="case-hero__total-value">{{ formatCurrency(caseData.akte.gesamt_saldo) }}</strong>
                  <span class="case-hero__total-hint">{{ 'caseView.totalClaimPrefix' | t }} {{ formatCurrency(caseData.akte.gesamt_forderung) }}</span>
                </article>
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.masterDataCreditor' | t }}</h3>
                <dl class="case-detail-grid">
                  @for (entry of masterEntries(caseData.akte); track entry.key) {
                    <div class="case-detail-item">
                      <dt>{{ entry.label }}</dt>
                      <dd>{{ entry.value }}</dd>
                    </div>
                  }
                </dl>
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.completeBreakdown' | t }}</h3>
                <div class="case-breakdown-grid">
                  <article class="case-breakdown-card">
                    <h4 class="case-breakdown-card__title">{{ 'caseView.breakdown.claim' | t }}</h4>
                    <dl class="case-inline-list">
                      @for (entry of forderungEntries(caseData.akte); track entry.key) {
                        <div><dt>{{ entry.label }}</dt><dd>{{ entry.value }}</dd></div>
                      }
                    </dl>
                  </article>
                  <article class="case-breakdown-card">
                    <h4 class="case-breakdown-card__title">{{ 'caseView.breakdown.payment' | t }}</h4>
                    <dl class="case-inline-list">
                      @for (entry of zahlungAufstellungEntries(caseData.akte); track entry.key) {
                        <div><dt>{{ entry.label }}</dt><dd>{{ entry.value }}</dd></div>
                      }
                    </dl>
                  </article>
                  <article class="case-breakdown-card">
                    <h4 class="case-breakdown-card__title">{{ 'caseView.breakdown.balance' | t }}</h4>
                    <dl class="case-inline-list">
                      @for (entry of saldoEntries(caseData.akte); track entry.key) {
                        <div><dt>{{ entry.label }}</dt><dd>{{ entry.value }}</dd></div>
                      }
                    </dl>
                  </article>
                  <article class="case-breakdown-card">
                    <h4 class="case-breakdown-card__title">{{ 'caseView.breakdown.dailyInterest' | t }}</h4>
                    <dl class="case-inline-list">
                      @for (entry of dailyInterestEntries(caseData.akte); track entry.key) {
                        <div><dt>{{ entry.label }}</dt><dd>{{ entry.value }}</dd></div>
                      }
                    </dl>
                  </article>
                </div>
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.glSettingsPermissions' | t }}</h3>
                <div class="case-breakdown-grid">
                  <article class="case-breakdown-card">
                    <h4 class="case-breakdown-card__title">{{ 'caseView.sections.effectivePermissions' | t }}</h4>
                    <dl class="case-inline-list">
                      @for (entry of permissionEntries(caseData.akte, caseData.permissions); track entry.key) {
                        <div><dt>{{ entry.label }}</dt><dd>{{ entry.value }}</dd></div>
                      }
                    </dl>
                  </article>
                  <article class="case-breakdown-card">
                    <h4 class="case-breakdown-card__title">{{ 'caseView.sections.glSettingMatrix' | t }}</h4>
                    <dl class="case-inline-list">
                      @for (entry of glSettingEntries(caseData.akte); track entry.key) {
                        <div><dt>{{ entry.label }}</dt><dd>{{ entry.value }}</dd></div>
                      }
                    </dl>
                  </article>
                </div>
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.invoicesWithCount' | t:{ count: caseData.rechnungen?.length ?? 0 } }}</h3>
                @if (caseData.rechnungen?.length) {
                  <div class="case-record-grid">
                    @for (invoice of caseData.rechnungen ?? []; track rowTrack(invoice, $index)) {
                      <article class="case-detail-record">
                        <h4>{{ 'caseView.records.invoice' | t:{ index: $index + 1 } }}</h4>
                        <dl class="case-detail-grid">
                          @for (entry of rowEntries(invoice); track entry.key) {
                            <div class="case-detail-item">
                              <dt>{{ entry.label }}</dt>
                              <dd>{{ entry.value }}</dd>
                            </div>
                          }
                        </dl>
                      </article>
                    }
                  </div>
                } @else {
                  <p class="case-empty">{{ 'caseView.noInvoices' | t }}</p>
                }
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.paymentsWithCount' | t:{ count: caseData.zahlungen?.length ?? 0 } }}</h3>
                @if (caseData.zahlungen?.length) {
                  <div class="case-record-grid">
                    @for (payment of caseData.zahlungen ?? []; track rowTrack(payment, $index)) {
                      <article class="case-detail-record">
                        <h4>{{ 'caseView.records.payment' | t:{ index: $index + 1 } }}</h4>
                        <dl class="case-detail-grid">
                          @for (entry of rowEntries(payment); track entry.key) {
                            <div class="case-detail-item">
                              <dt>{{ entry.label }}</dt>
                              <dd>{{ entry.value }}</dd>
                            </div>
                          }
                        </dl>
                      </article>
                    }
                  </div>
                } @else {
                  <p class="case-empty">{{ 'caseView.noPayments' | t }}</p>
                }
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.titlesWithCount' | t:{ count: caseData.titel?.length ?? 0 } }}</h3>
                @if (caseData.titel?.length) {
                  <div class="case-record-grid">
                    @for (title of caseData.titel ?? []; track rowTrack(title, $index)) {
                      <article class="case-detail-record">
                        <h4>{{ 'caseView.records.title' | t:{ index: $index + 1 } }}</h4>
                        <dl class="case-detail-grid">
                          @for (entry of rowEntries(title); track entry.key) {
                            <div class="case-detail-item">
                              <dt>{{ entry.label }}</dt>
                              <dd>{{ entry.value }}</dd>
                            </div>
                          }
                        </dl>
                      </article>
                    }
                  </div>
                } @else {
                  <p class="case-empty">{{ 'caseView.noTitles' | t }}</p>
                }
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.ratesWithCount' | t:{ count: caseData.raten?.length ?? 0 } }}</h3>
                @if (caseData.raten?.length) {
                  <div class="case-record-grid">
                    @for (rate of caseData.raten ?? []; track rowTrack(rate, $index)) {
                      <article class="case-detail-record">
                        <h4>{{ 'caseView.records.rate' | t:{ index: $index + 1 } }}</h4>
                        <dl class="case-detail-grid">
                          @for (entry of rowEntries(rate); track entry.key) {
                            <div class="case-detail-item">
                              <dt>{{ entry.label }}</dt>
                              <dd>{{ entry.value }}</dd>
                            </div>
                          }
                        </dl>
                      </article>
                    }
                  </div>
                } @else {
                  <p class="case-empty">{{ 'caseView.noRates' | t }}</p>
                }
              </section>

              <section class="case-section">
                <h3 class="case-section__title">{{ 'caseView.sections.locationOfficeBank' | t }}</h3>
                @if (caseData.standort) {
                  <dl class="case-detail-grid">
                    @for (entry of rowEntries(caseData.standort); track entry.key) {
                      <div class="case-detail-item">
                        <dt>{{ entry.label }}</dt>
                        <dd>{{ entry.value }}</dd>
                      </div>
                    }
                  </dl>
                } @else {
                  <p class="case-empty">{{ 'caseView.noLocation' | t }}</p>
                }
              </section>

              @if (unknownAkteEntries(caseData.akte).length || caseData.raw_case_json || unknownRootEntries(caseData).length) {
                <section class="case-section">
                  <h3 class="case-section__title">{{ 'caseView.sections.additionalApiFields' | t }}</h3>
                  @if (unknownAkteEntries(caseData.akte).length) {
                    <article class="case-detail-record">
                      <h4>{{ 'caseView.sections.additionalCaseData' | t }}</h4>
                      <dl class="case-detail-grid">
                        @for (entry of unknownAkteEntries(caseData.akte); track entry.key) {
                          <div class="case-detail-item">
                            <dt>{{ entry.label }}</dt>
                            <dd>{{ entry.value }}</dd>
                          </div>
                        }
                      </dl>
                    </article>
                  }
                  @if (caseData.raw_case_json) {
                    <article class="case-detail-record">
                      <h4>{{ 'caseView.sections.additionalRootData' | t }}</h4>
                      <pre class="case-raw-json">{{ formatRawCaseJson(caseData.raw_case_json) }}</pre>
                    </article>
                  } @else if (unknownRootEntries(caseData).length) {
                    <article class="case-detail-record">
                      <h4>{{ 'caseView.sections.additionalRootData' | t }}</h4>
                      <dl class="case-detail-grid">
                        @for (entry of unknownRootEntries(caseData); track entry.key) {
                          <div class="case-detail-item">
                            <dt>{{ entry.label }}</dt>
                            <dd>{{ entry.value }}</dd>
                          </div>
                        }
                      </dl>
                    </article>
                  }
                </section>
              }
            } @else {
              <p class="case-modal__state">{{ 'caseView.noDbData' | t }}</p>
            }
          }
        </div>
      </div>
    </div>
  }
}

@if (impressumOpen()) {
  <app-impressum-modal
    [standortClz]="impressumStandortClz()"
    (close)="closeImpressum()">
  </app-impressum-modal>
}

@if (i18n.languageSwitchOverlay(); as overlay) {
  <div class="language-switch-overlay" role="status" aria-live="polite" [attr.aria-label]="overlay.message">
    <div class="language-switch-overlay__panel">
      <span class="language-switch-overlay__spinner" aria-hidden="true"></span>
      <span class="language-switch-overlay__flag" aria-hidden="true">{{ overlay.flag }}</span>
      <p class="language-switch-overlay__message">{{ overlay.message }}</p>
    </div>
  </div>
}

@if (datenschutzOpen()) {
  <app-datenschutz-modal [standortClz]="activeStandortClz()" (close)="datenschutzOpen.set(false)"></app-datenschutz-modal>
}
